module.exports = __webpack_public_path__ + "合作2.png?ad16850d405d6d8b10ece9d4fc587cfc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/合作2.png
// module id = 644
// module chunks = 0